import Said from '../assets/images/layout/Said-Jimenez.jpg';
import Balam from '../assets/images/layout/BalamTzibtah_Pic.png';
import { div } from 'framer-motion/client';

export default function Autores() {
  return (
    <div className='autores_section'>
        <div className="row" style={{ paddingBottom: '40px' }}>
          <div className="col-12">
            <h3>Los autores</h3>
          </div>
        </div>
        <div className="row author_row justify-content-center">
          <div className="col-md-3">
            <div className="author" style={{ backgroundImage: `url(${Said})`, backgroundPosition: 'center' }}></div>
          </div>
          <div className="col-md-6 bio">
            <h4>Said Jiménez</h4>
            <p>
              Said Jiménez, un narrador con una vida dedicada al arte de contar historias desde los 10 años, presenta su esperada ópera prima, "Noche de muertos, día de la vida". Con una trayectoria que abarca ocho musicales y diversas producciones en televisión y cine, su formación en The Lee Strasberg Theatre & Film Institute en Nueva York le permitió profundizar en la narrativa y su adaptación. A sus 42 años, Jiménez demuestra su versatilidad al haber escrito obras de teatro, series y documentales. Esta obra representa la culminación de su experiencia y pasión por la escritura, invitando a niños y adolescentes a sumergirse en narrativas cautivadoras que estimulan la imaginación y el entendimiento del mundo que los rodea.
            </p>
            <p>
              <a href="https://www.instagram.com/darksaidmx/" target='_blank' rel="noopener noreferrer">@darksaidmx</a>
            </p>
          </div>
        </div>
        <div className="row author_row justify-content-center">
          <div className="col-md-3">
            <div className="author" style={{ backgroundImage: `url(${Balam})`, backgroundPosition: 'center' }}></div>
          </div>
          <div className="col-md-6 bio">
            <h4>Balam Tzibtah</h4>
            <p>
              Balam Tzibtah es un artista visual originario de la gran Tenochtitlan. Su obra se centra en la reinterpretación contemporánea de las costumbres, tradiciones y estética de las culturas ancestrales de Mesoamérica, con una profunda exploración en la iconografía maya. A través de un lenguaje visual único, entre lo onírico y lo ancestral, su trabajo busca tender un puente entre el pasado glorioso, el presente vibrante y un futuro lleno de orgullo. Con una trayectoria presente en la escena del arte actual, su sello distintivo es la fusión de símbolos antiguos con técnicas modernas. En esta obra, su arte da vida y color a la palabra, complementando y enriqueciendo la historia.
            </p>
            <p>
              <a href="https://www.instagram.com/balamtzibtah/" target='_blank' rel="noopener noreferrer">@balamtzibtah</a>
            </p>
          </div>
        </div>
        </div>
  );
}